const brands = [
  { name: "Daikin", logo: "https://airconditioningguys.com.au/uploads/brand_logo/daikin.png" },
  { name: "Fujitsu", logo: "https://airconditioningguys.com.au/uploads/brand_logo/fujitsu.png" },
  { name: "ActronAir", logo: "https://airconditioningguys.com.au/uploads/brand_logo/actronair.png" },
  { name: "Mitsubishi", logo: "https://airconditioningguys.com.au/uploads/brand_logo/mitsubishi.png" },
  { name: "Samsung", logo: "https://airconditioningguys.com.au/uploads/brand_logo/samsung.png" },
  { name: "LG", logo: "https://airconditioningguys.com.au/uploads/brand_logo/lg.png" },
];

const BrandPartners = () => {
  return (
    <section className="px-4 pb-16">
      <div className="container mx-auto">
        {/* Dark header bar */}
        <div className="bg-[#2D3436] rounded-t-lg py-3 px-6 text-center">
          <p className="text-white text-sm font-medium tracking-wide">
            Authorised Dealers for:
          </p>
        </div>

        {/* Brand logos */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 mt-4">
          {brands.map((brand) => (
            <div
              key={brand.name}
              className="bg-white rounded-lg shadow-md flex items-center justify-center p-6 h-28"
            >
              <img
                src={brand.logo}
                alt={`${brand.name} air conditioning brand logo — authorised dealer`}
                className="max-h-12 max-w-full object-contain"
                width={120}
                height={48}
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BrandPartners;
